import { snakeCase, isEmpty, forOwn, has } from 'lodash';
import ActiveCache            from './cache.active';
import queryHelper            from './query.helper';

const API_URL = process.env.API_URL || 'http://localhost:3000';

class ActiveService extends ActiveCache{
  /**
   *
   * @param $injector
   */
  constructor(
    $injector
  ){

    'ngInject';

    super();

    this.$injector = $injector;

    this.$q       = $injector.get('$q');
    this.$http    = $injector.get('$http');
    this.notify   = $injector.get('ngNotify');
    this.config   = $injector.get('CONFIG');
    this.uri      = null;
    this.block    = false;

    this.collections = {};

  }

  /**
   *
   * @param url
   * @param query
   * @returns {Function}
   */
  activeGet(
    url     = null,
    query   = null
  ){
    let deferred    = this.$q.defer();
    let config;
    if( !isEmpty( query ) ){
       config      = {
          paramSerializer : '$httpParamSerializerJQLike',
          params    : queryHelper( query )
        };
    }
    this.$http
      .get( `${API_URL}${url}` , config )
      .then( response => {
        deferred.resolve( response.data );
      } )
      .catch( errors => deferred.reject( errors ) );
    return deferred.promise;
  }

  /**
   *
   * @param url
   * @param data
   * @returns {Function}
   */
  activePost(
    url     = null,
    data    = null,
    config        = null
  ){
    if( false === this.block ){
      let deferred = this.$q.defer();
      this.$http
        .post( `${API_URL}${url}`, data, config )
        .then( response => {
          this.block = false;
          deferred.resolve( response.data )
        } )
        .catch( errors => deferred.reject( errors ) );
      return deferred.promise;
    }
  }

  activePostDirect(
    url     = null,
    data    = null,
    config        = null
  ){
    if( false === this.block ){
      let deferred = this.$q.defer();
      this.$http
        .post( `${url}`, data, config )
        .then( response => {
          this.block = false;
          deferred.resolve( response.data )
        } )
        .catch( errors => deferred.reject( errors ) );
      return deferred.promise;
    }
  }

  /**
   *
   * @param url
   * @param data
   * @returns {Function}
   */
  activePut(
    url = null ,
    data = null
  ){
    let deferred = this.$q.defer();
    this.$http
      .put( `${API_URL}${url}`, data )
      .then( response => deferred.resolve( response.data ) )
      .catch( errors => deferred.reject( errors ) );
    return deferred.promise;
  }

  /**
   *
   * @param url
   * @returns {*|Function|jQuery.promise|promise.promise|b.promise|d.promise}
   */
  activeDelete( url ){
    try{
      let deferred = this.$q.defer();
      this.$http
        .delete( `${API_URL}${url}` )
        .then( response => deferred.resolve( response.data ) )
        .catch( errors => deferred.reject( errors ) );
      return deferred.promise;
    } catch( e ) {
      console.log('ActiveService > activeDelete with reason: ' + e);
    }
  }

  /**
   *
   * @param id
   * @param type
   * @returns {Function}
   */
  sub(
    id = null,
    type = null
  ){
    return this.activeGet(`${this.getUri()}/${id}/${snakeCase( type ).replace(/_/g, '-')}`);
  }

  /**
   *
   * @param uri
   */
  setUri( uri ){
    this.uri = uri;
  }

  /**
   *
   * @returns {*}
   */
  getUri(){
    if( null === this.uri ){
      this.block = true;
      return console.log( 'ActiveService > getUri , uri mu be set' );
    }
    this.block = false;
    return this.uri;
  }

  /**
   *
   * @param search
   * @returns {Function}
   */
  list( search ){
    return this.activeGet( `${this.getUri()}` , search );
  }

  /**
   *
   * @param data
   * @returns {Function}
   */
  create( data ){
    return this.activePost( `${this.getUri()}`, data );
  }

  /**
   *
   * @param id
   * @returns {Function}
   */
  retrieve( id ){
    return this.activeGet( `${this.getUri()}/${id}` );
  }

  /**
   *
   * @param id
   * @param data
   * @returns {Function}
   */
  update( id, data ){
    return this.activePut( `${this.getUri()}${id}`, data );
  }

  /**
   *
   * @param id
   * @returns {*|Function|jQuery.promise|promise.promise|b.promise|d.promise}
   */
  destroy( id ){
    return this.activeDelete( `${this.getUri()}${id}` );
  }

  $search(baseUri, requestConfiguration, referenceName) {

		let additional = "?query={}", uri, isBoolean = (value) => typeof(value) === "boolean" ? value : `"${value}"`;

		let getFilters = () => {
			let filter = "";
			forOwn(requestConfiguration.filter, (value, key) => {
				if(has(value, 'uri')){
					return filter += `"${key}": "${value.uri}",`;
				}
				else if(null !== value){
					return filter += `"${key}": ${isBoolean(value)},`;
				}
			});
			return filter.slice(0, -1);
		};

		try {

			if (requestConfiguration && requestConfiguration.search) {
				additional = `?query={"_global": "${requestConfiguration.search}"}`;
			}

			if (requestConfiguration && requestConfiguration.filter) {
				additional = `?query={${getFilters()}}`;
			}

			if (requestConfiguration.search && requestConfiguration.filter) {
				const filters = getFilters();
			  additional = "?query={" +
					`"_global": "${requestConfiguration.search}" ${(filters !== '' ? ',' + filters : '')}}`;
			}

			if (requestConfiguration.order) {
				additional = `${additional}&order=${requestConfiguration.order}`;
			}

			if (requestConfiguration.limit) {
				additional = `${additional}&limit=${requestConfiguration.limit}`;
			}

			if (requestConfiguration.cursor) {
				additional = `${additional}&with_cursor=1`;
			}

			uri = requestConfiguration.search ? baseUri + additional : (requestConfiguration.next_uri ? requestConfiguration.next_uri : baseUri + additional );

		} catch (e) {
			uri = baseUri;
		}

		return this.activeGet(uri);

	}

}
export default ActiveService;


/** WEBPACK FOOTER **
 ** ./frontend/@/service.active.js
 **/